let customHeaders = {}
let authToken, session = window.sessionStorage.getItem('session');
if (session) {
  authToken = JSON.parse(session)
  authToken = authToken?.token
  customHeaders['x-access-token'] = authToken
} else {
  window.location.replace(`${process.env.REACT_APP_API_ORIGIN}/login`);
}

export const headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  ...customHeaders
};
